import { defineMessages } from 'react-intl';

export const messages: {
	datePlaceholder: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	datePlaceholder: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.date-input.edit.date-placeholder',
		description: 'Placeholder for the date input field when no date is selected',
		defaultMessage: 'e.g. {date}',
	},
});
